import { SystemPromptData } from "@/common/system-prompts";
import { Button } from "@/components/ui/button";
import React, { useEffect, useState } from "react";

interface SystemPromptFilterProps {
  systemPrompts: SystemPromptData[] | null;
  onChange: (filters: string[]) => void;
}

interface SystemPromptPillar {
  id: string;
  pillar: string;
  title: string;
}

const SystemPromptFilters: React.FC<SystemPromptFilterProps> = ({
  systemPrompts,
  onChange,
}) => {
  const [activeSystemPromptPillars, setActiveSystemPromptPillars] = useState<
    SystemPromptPillar[]
  >([]);

  const [systemPromptPillars, setSystemPromptPillars] = useState<
    SystemPromptPillar[]
  >([]);

  useEffect(() => {
    if (systemPrompts === null) {
      setSystemPromptPillars([]);
      return;
    }

    const pillars: SystemPromptPillar[] = Array.from(
      new Map(
        systemPrompts.map((item) => {
          const pillar = item.node.split(".")[0];
          const title = pillar
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());

          return [pillar, { pillar, title, id: pillar }]; // map by pillar to remove duplicates
        }),
      ).values(),
    );

    setSystemPromptPillars(pillars);
  }, [systemPrompts]);

  useEffect(() => {
    onChange(activeSystemPromptPillars.map((item) => item.pillar));
  }, [activeSystemPromptPillars, onChange]);

  const handleFilter = (filter: SystemPromptPillar | null) => {
    if (filter === null) {
      setActiveSystemPromptPillars([]);
      return;
    }

    const newFilters = [...activeSystemPromptPillars];

    const foundFilterIndex = newFilters.findIndex(
      (activeFilter) => activeFilter === filter,
    );

    if (foundFilterIndex === -1) {
      newFilters.push(filter);
    } else {
      newFilters.splice(foundFilterIndex, 1);
    }

    setActiveSystemPromptPillars(newFilters);
  };

  return (
    <div className="sys-prompt-grid gap-3 pt-4 overflow-x-auto">
      <Button
        type="button"
        className={`${
          activeSystemPromptPillars.length === 0
            ? "bg-sky-500 border-sky-500"
            : "bg-sky-100 border-sky-700 text-black"
        } border rounded-full justify-central hover:bg-sky-200 hover:border-sky-700 hover:text-black`}
        onClick={() => handleFilter(null)}
      >
        All
      </Button>

      <h3 className="text-black font-bold ml-6">Pillar</h3>

      <div className="flex gap-3">
        {systemPromptPillars.map((item) => (
          <Button
            key={item.id}
            type="button"
            className={`${
              activeSystemPromptPillars.includes(item)
                ? "bg-sky-500 border-sky-500"
                : "bg-sky-100 border-sky-700 text-black"
            } border rounded-full justify-central hover:bg-sky-200 hover:border-sky-700 hover:text-black`}
            onClick={() => handleFilter(item)}
          >
            {item.title}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SystemPromptFilters;
